import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { Themable } from 'src/types/themable'

export const InformationCard = styled.div<Themable>`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S16};
  border: 1px solid ${({ theme }) => theme.colors.gray2};
  border-radius: 6px;
  padding: ${Spacing.S16};
`
